import { useMutation } from '@tanstack/react-query'
import api from '../../config/axios-config'
import { authorization } from '../../../containers/authentication/constants'
import { useAuthStore } from '../../../zustand/authentication/use-auth-store'
import { authMutationKeys } from '../constants'

export const useLoginRedirectMutation = () => {
  const { setPasswordPolicy, setShow2FA, loginRedirectSuccessful } =
    useAuthStore()

  const handleLoginCredentials = async (email, password) => {
    const config = {
      method: 'post',
      headers: {
        Authorization: authorization
      },
      data: {
        username: email,
        password,
        grant_type: 'password'
      }
    }

    const response = await api('/api/oauth/token', config)

    return response
  }

  const handleTwoFactor = async (email) => {
    const config = {
      method: 'get',
      params: {
        email
      },
      headers: null
    }

    const { data } = await api('/api/twoFactor', config)

    return data
  }

  const handleMutation = async ({ email, password }) => {
    const { twoFAResponse } = await handleTwoFactor(email)
    setPasswordPolicy(twoFAResponse)

    if (twoFAResponse?.data) {
      setShow2FA(twoFAResponse)
    } else {
      const response = await handleLoginCredentials(email, password)

      loginRedirectSuccessful(response)
    }
  }

  return useMutation({
    mutationFn: async (credentials) => await handleMutation(credentials),
    mutationKey: authMutationKeys.REDIRECT
  })
}
